import type { EmployeeNumberSettings } from './types';
const ruleFields = [
  'prefix',
  'dateBasis',
  'dateFormat',
  'sequenceLength',
  'resetCycle',
  'sequenceScope',
  'reuseFormerWorkerId',
] as const;
export function ruleKey(settings: EmployeeNumberSettings) {
  return JSON.stringify(Object.fromEntries(ruleFields.map((field) => [field, settings[field]])));
}
export function normalizeEmployeeNumberSettings(settings: EmployeeNumberSettings): EmployeeNumberSettings {
  return {
    ...settings,
    reuseFormerWorkerId: settings.reuseFormerWorkerId ?? false,
  };
}
export function previewParts(settings: EmployeeNumberSettings) {
  const now = new Date();
  const year = String(now.getUTCFullYear());
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  const date =
    settings.dateFormat === 'YY'
      ? year.slice(-2)
      : settings.dateFormat === 'YYMM'
        ? `${year.slice(-2)}${month}`
        : settings.dateFormat === 'YYYYMM'
          ? `${year}${month}`
          : '';
  return {
    prefix: settings.prefix,
    date,
    sequence: '1'.padStart(settings.sequenceLength, '0'),
  };
}
export function dateBasisLabel(value: EmployeeNumberSettings['dateBasis']) {
  return value === 'HIRE_DATE' ? '입사일 기준' : '발급 처리일 기준';
}
export function dateFormatLabel(value: EmployeeNumberSettings['dateFormat']) {
  return value === 'NONE' ? '날짜 없음' : value;
}
